import { TableMessage } from '@genial/components';
import React from 'react';

export const InvalidColumns: React.FC = () => {
  return (
    <TableMessage
      testId="table-customer-invalid-columns"
      color="feedback.attention.default"
      icon="Warning">
      As larguras das colunas não somam 100%
    </TableMessage>
  );
};
